import { render } from "./EditEmailText.vue?vue&type=template&id=471d87a2"
import script from "./EditEmailText.vue?vue&type=script&lang=js"
export * from "./EditEmailText.vue?vue&type=script&lang=js"

import "./EditEmailText.vue?vue&type=style&index=0&id=471d87a2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__